<template>
  <div class="pulsate-icon">
    <div :class="[pulsateColor, size]"
         class="pulsate-icon__pulsate-container">
    </div>

    <div :class="[pulsateColor, size]"
         class="pulsate-icon__border-container"></div>

    <div :class="[pulsateColor, size]"
         class="pulsate-icon__content-container">
      <span v-if="icon"
            :class="icon"/>

      <slot/>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'pulsate-icon',
    props: {
      icon: {type: String},
      pulsateColor: {type: String},
      size: {type: String, default: 'large'}, //medium, large
    },
  }
</script>

<style lang="scss">
  @import "@/assets/styles/applications.scss";

  .pulsate-icon {
    position: relative;

    &__pulsate-container {
      border-radius: 50%;
      -webkit-animation: puff-out-center 1s ease-out infinite;
      animation: puff-out-center 1s ease-out infinite;

      &.medium {
        width: 100px;
        height: 100px;
      }

      &.large {
        width: 175px;
        height: 175px;
      }

      &.red {
        background-color: rgba(#DA25251A, 0.1);
      }

      &.blue {
        background-color: rgba(#736FDC1A, 0.1);
      }

      &.green {
        background-color: rgba(#25CA851A, 0.1);
      }
    }

    &__border-container {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);

      background-color: rgba(color(white), 50%);
      border-radius: 50%;

      &.medium {
        width: 100px;
        height: 100px;
        border: 12px solid;
      }

      &.large {
        width: 130px;
        height: 130px;
        border: 15px solid;
      }

      &.red {
        border-color: rgba(#DA25251A, 0.1);
      }

      &.blue {
        border-color: rgba(#736FDC1A, 0.1);
      }

      &.green {
        border-color: rgba(#25CA851A, 0.1);
      }
    }

    &__content-container {
      @extend %layout--flex-center-xy;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);

      &.medium {
        width: 75px;
        height: 75px;
      }

      &.large {
        width: 105px;
        height: 105px;
      }

      [class^="ns-icon"]::before {
        font-size: 100px;
        cursor: default;
      }
    }
  }

  @-webkit-keyframes puff-out-center {
    0% {
      -webkit-transform: scale(1);
              transform: scale(1);
      -webkit-filter: blur(0px);
              filter: blur(0px);
      opacity: 1;
    }
    100% {
      -webkit-transform: scale(2);
              transform: scale(2);
      -webkit-filter: blur(4px);
              filter: blur(4px);
      opacity: 0;
    }
  }

  @keyframes puff-out-center {
    0% {
      -webkit-transform: scale(1);
              transform: scale(1);
      -webkit-filter: blur(0px);
              filter: blur(0px);
      opacity: 1;
    }
    100% {
      -webkit-transform: scale(2);
              transform: scale(2);
      -webkit-filter: blur(4px);
              filter: blur(4px);
      opacity: 0;
    }
  }
</style>
